/**
 * Feature Flag Constants
 *
 * This file defines all feature flag keys used throughout the application.
 * Each constant maps to a flag name in Firebase Remote Config.
 *
 * GOVERNANCE:
 * - Naming convention: (team[a-z]+|shared|system)_[a-z]+_[a-z_]+
 * - Max length: 64 characters
 * - All flags must have corresponding entries in feature-flag-registry.ts
 * - Active flags must appear in flag-manifests/current.manifest.ts
 *
 * DOCUMENTATION:
 * - Rules of Engagement: https://nbcu-ot.atlassian.net/wiki/spaces/UDXWEB/pages/2592506502/
 * - Promotion Flow: https://nbcu-ot.atlassian.net/wiki/spaces/UDXWEB/pages/2591588864/
 *
 * USAGE:
 * - Create new flags with: npm run ff:create
 * - Validate flags with: npm run ff:validate
 *
 * DO NOT manually edit this file — use the ff:create wizard to ensure consistency.
 */

export const FEATURE_FLAGS = {
  // Example entries (remove these and add your own):
  // TEAM_A_CHECKOUT_REDESIGN_ENABLED: 'teama_checkout_redesign_enabled',
  // SHARED_SEARCH_AUTOCOMPLETE_ENABLED: 'shared_search_autocomplete_enabled',
  GUESTACCOUNT_ONETRUSTPRIVACYCHOICES:
    'teammodernization_guestaccount_onetrustprivacychoices_enabled',
  GUESTACCOUNT_PROFILESELECTION:
    'teamddev_guestaccount_profileselection_enabled',
  GUESTACCOUNT_FAVORITES: 'teamddev_guestaccount_favorites_enabled',
} as const;

export type FeatureFlagKey = keyof typeof FEATURE_FLAGS;
export type FeatureFlagValue = (typeof FEATURE_FLAGS)[FeatureFlagKey];
